export default {
  today: 'Today',
  thisWeek: 'Current Week',
  thisMonth: 'Current Month',
  last3Months: 'Last 3 months',
  last6Months: 'Last 6 Months',

  upcoming: 'Upcoming',
  upcomingToday: 'Upcoming today',
  urgentlyUpcoming: 'Urgently upcoming',
  doneOnTime: 'Done on time',
  missedDeadline: 'Missed deadline',
  onsiteMissedDeadline: 'Onsite missed deadline',
  onsiteDoneOnTime: 'Onsite done on time',
  completionDoneOnTime: 'Completion done on time',
  completionMissedDeadline: 'Completion missed deadline',

  new: 'New',
  inProgress: 'In Progress',
  allocated: 'Allocated',
  onHold: 'On Hold',
  finished: 'Finished',
  workCompleted: 'Work Completed',
  cancelled: 'Cancelled',

  Y1: 'Annual',
  M1: 'Monthly',
  M3: 'Quarterly',
  M6: 'Half Yearly',
  M2: 'Bi-Monthly',
  M4: 'Four Monthly',
  Y2: '2 Yearly',
  Y3: '3 Yearly',
  Y4: '4 Yearly',
  Y5: '5 Yearly',
  Y6: '6 Yearly',
  D1: 'Daily',
  D7: 'Weekly',
  F1: 'Fortnightly',

  completed: 'Completed',
  incomplete: 'Incomplete',
  open: 'Open',
};
